import axiosWithToken from '@/api/axios'
import { adminBaseUrl } from '@/store'
import { postMethodConfig } from '@/api/axios'

const state = () => ({
  sliders: [],
  isLoading: false
})

const getters = {
  sliders: (state) => state.sliders,
  isLoading: (state) => state.isLoading
}

const mutations = {
  SET_SLIDERS(state, payload) {
    state.sliders = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  }
}

const actions = {
  fetchSliders({ commit, dispatch }) {
    commit('SET_LOADING', true)
    axiosWithToken
      .get('/api/dashboard/slider')
      .then((res) => {
        commit('SET_SLIDERS', res.data.message)
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        commit('SET_LOADING', false)
      })
  },
  createSingleSlider({ dispatch }, { payload, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/slider`, data, postMethodConfig)
      .then(() => {
        vm.$router.push('/admin/sliders')
      })
      .catch((err) => {
        console.error(err)
        dispatch('auth/requestAuthError', err, { root: true })
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  deleteSingleSlider(_context, { id, vm }) {
    axiosWithToken
      .delete(`${adminBaseUrl}/slider/${id}`)
      .then(() => {
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
  },
  fetchSingleSlider(_context, { id, vm }) {
    vm.isLoading = true
    axiosWithToken
      .get(`${adminBaseUrl}/slider/${id}`)
      .then((res) => {
        const message = res.data.message
        vm.imageUrlEn = message.image_en
        vm.imageUrlRu = message.image_ru
        vm.editForm.link = message.link
        vm.editForm.sort = message.sort
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  },
  updateSingleSlider(_context, { payload, id, vm }) {
    const data = new FormData()
    for (const key in payload) {
      data.append(key, payload[key])
    }
    data.append('_method', 'PUT')

    vm.isLoading = true
    axiosWithToken
      .post(`${adminBaseUrl}/slider/${id}`, data, postMethodConfig)
      .then(() => {
        vm.$refs['editSingleSliderModal'].hide()
        vm.$emit('update')
      })
      .catch((err) => {
        console.error(err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
